<template>
  <div class="task-step-specific-info-card">
    <div v-if="!stepInfo" class="no object-card">
      <span>{{ $t('SelectStep') }}</span>
    </div>
    <div v-else :style="{ 'height': '100%' }">
      <tabs
        :tabs="tabs"
        :active-tab="activeTab"
        :tabs-styling="tabsStyling"
        :tabs-labels-styling="tabsLabelsStyling"
        :center-tabs="false"
      />
      <div id="fields-div">
        <fields-list
          id="common-task-fields-div"
          :fields="fields"
          :editing-data="false"
          :hide-lines="true"
          :style="{ 'flex-grow': '0' }"
        />
        <div class="task-value-container" :style="{ 'padding': stepInfo.type === 'photo' ? '0px' : '12px 0 7.5px 20px' }">
          <div v-if="stepInfo.type === 'photo'" class="photo">
            <div
              v-if="!stepInfo.value"
              class="no-photo"
            >
              <v-icon>photo_camera</v-icon>
            </div>
            <img
              v-else
              class="task-photo"
              :src="stepInfo.value"
              alt="Task Photo"
            />
          </div>

          <div v-if="stepInfo.type === 'text'" class="text">
            <v-icon>subject</v-icon>
            <span>{{ stepInfo.value }}</span>
          </div>

          <div v-if="stepInfo.type === 'checkbox'" class="checkbox">
            <v-icon>{{ stepInfo.value === true ? 'check' : 'check_box_outline_blank' }}</v-icon>
            <span>{{ stepInfo.value ? $t('Done') : $t('NotFinished') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import { bus } from '@/main.js';

export default {
  name: "TaskStepSpecificInfo",

  components: {
    Tabs,
    FieldsList,
  },

  data() {
    return {
      activeTab: 0,
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'font-size': '10px',
        'text-transform': 'none',
        'letter-spacing': '0',
      },

      stepInfo: null,

      noPhotoDivHeight: 'auto',
    }
  },

  mounted() {
    bus.$on('update-selected-task-step-data', data => this.stepInfo = {...data});
  },

  destroyed() {
    bus.$off("update-selected-task-step-data");
  },

  computed: {
    tabs() {
      return [
        { id: 'step', label: this.$i18n.tc("Step", 1) },
      ]
    },

    fields() {
      return this.stepInfo
        ? [
            {
              icon: "label",
              label: this.$i18n.tc("Label", 1),
              value: this.stepInfo.label,
              size: "100%"
            },
            {
              icon: "location_on",
              label: this.$i18n.t("Required"),
              value: this.stepInfo.required ? this.$i18n.t('Yes') : this.$i18n.t('No'),
              size: "100%"
            },
            {
              icon: "label",
              label: this.$i18n.tc("Type", 1),
              value: this.stepInfo.type,
              size: "100%"
            },
          ]
        : [];
    },

  },
}
</script>

<style scoped>
.task-step-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  background-color: #fff;
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: auto;
  max-height: 70%;
}

.v-tabs >>> .v-tabs-bar {
  height: 39px;
}

.no.object-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.no.object-card > span {
  color: #29BDF0;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
}

.v-icon {
  line-height: 0;
  color: #29BDF0;
  font-size: 15px;
  height: 15px;
}

.text,
.checkbox {
  display: flex;
  max-width: 100%;
  line-break: anywhere;
  gap: 8px;
  align-items: flex-start;
}

.photo {
  margin-top: 8px;
}

.task-value-container {
  text-align: left;
  display: flex;
  flex-grow: 1;
}

.task-value-container span {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 11.5px;
  text-align: justify;
}

.task-value-container .checkbox span {
  line-height: 15px;
}

.no-photo {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

.task-photo,
.no-photo {
  height: 100%;
  border: 1px solid rgba(219, 219, 224, 1);
  border-radius: 8px;
}

.no-photo .v-icon {
  height: 96px;
  font-size: 96px;
}

#fields-div {
  height: 88%;
  display: flex;
  flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/TasksManagement/TaskStepSpecificInfo.vue